import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { myfetchThunk } from "../../../app/myfetch";
import { masteruri } from "../../../config";
import { message } from "antd";
import { loginActions } from "../../Login/actions/LoginAction";
import { renewedToken } from "../../Login/typing/renewed_token_logic";

/**
 * Wechselt das eigene Passwort.
 *
 * Das Passwort geht im Klartext ueber die (TLS-gesicherte) Verbindung. Die
 * aelteren Passwortpfade verpacken es zusaetzlich in Base64 mit vorn 14 und
 * hinten 18 Fuellzeichen - das ist keine Verschluesselung, sondern nur eine
 * andere Schreibweise desselben Klartexts. Neuer Code uebernimmt das nicht.
 */
export const requestPasswortwechsel = (
    altesPasswort: string,
    neuesPasswort: string,
    history: { push: (pfad: string) => void },
) => {
    return (dispatch: Dispatch<any>, _getState: () => RootState) => {
        dispatch(myfetchThunk(
            true,
            masteruri + "/users/passwortwechsel",
            { AltesPasswort: altesPasswort, NeuesPasswort: neuesPasswort },
            "POST",
            (payload: any) => {
                // Der Server antwortet mit dem neuen Status. Kommt etwas
                // anderes zurueck, ist der Wechsel nicht durchgegangen - dann
                // hier nicht weiterleiten, sonst landet der Benutzer auf einer
                // Seite, die ihm nur 403 liefert.
                if (payload && payload.pw_status === 0) {
                    // The change ended every session of the account, this
                    // one too (anima_core#24); it goes on with the renewed token.
                    const token = renewedToken(payload);
                    if (token !== null) {
                        dispatch(loginActions.renewToken({ token }));
                    }
                    message.success({
                        content: "Passwort geändert.",
                        key: "pwwechsel",
                        duration: 3,
                    });
                    history.push("/dashboard");
                } else {
                    message.error({
                        content: (payload && payload.message)
                            || "Das Passwort konnte nicht geändert werden.",
                        key: "pwwechsel",
                        duration: 6,
                    });
                }
            },
            (payload: any) => {
                message.error({
                    content: (payload && payload.message)
                        || "Das Passwort konnte nicht geändert werden.",
                    key: "pwwechsel",
                    duration: 6,
                });
            },
        ) as any);
    };
};
